import { parseJSON } from 'date-fns';
import { useCallback, useEffect, useState } from 'react';

import { ListingApplicationListingType } from 'api/types/ListingApplicationListingType';
import { fetchApplications } from 'modules/orgDashboard/api/orgDashboardApiListingApplication';
import { OrgDashboardApiListing } from 'modules/orgDashboard/api/types/OrgDashboardApiListing';
import { OrgDashboardApiListingApplicationMini } from 'modules/orgDashboard/api/types/OrgDashboardApiListingApplicationMini';
import { OrgDashboardApiOrg } from 'modules/orgDashboard/api/types/OrgDashboardApiOrg';
import {
  StaffApiListing as StaffListing,
  StaffApiOrg as StaffOrg,
} from 'modules/staff/api/orgs';
import {
  NOTIFICATIONS,
  dismissNotification,
  getNotificationStatus,
  notificationIsDismissed,
  setNotificationStatus,
} from 'utils/localNotifications';
// eslint-disable-next-line import/no-namespace
import * as localStorage from 'utils/localStorage';

const NEW_STATUS_START_DATE = '2021-07-14T15:00:00Z';

type ApplicationSearch = (
  arg0: string,
  arg1: string | null | undefined,
  arg2: ListingApplicationListingType,
  arg3: number | null | undefined,
) => {
  loading: boolean;
  applications: Array<OrgDashboardApiListingApplicationMini> | null | undefined;
  count: number | null | undefined;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  search: (...args: Array<any>) => any;
  searchIndex: number;
};
export const useApplicationSearch: ApplicationSearch = (
  orgId,
  listingId,
  listingType,
) => {
  const [loading, setLoading] = useState(true);
  const [applications, setApplications] = useState();
  const [count, setCount] = useState();
  const [searchIndex, setSearchIndex] = useState(0);
  const search = useCallback(() => {
    const params = {
      id: listingId,
      type: listingType,
    };
    fetchApplications(orgId, params).then((response) => {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      setApplications(response.listingApplications);
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      setCount(response.count);
      setSearchIndex((prev) => prev + 1);
      setLoading(false);
    });
  }, [listingId, listingType, orgId]);
  useEffect(() => {
    search();
  }, [listingId, listingType, orgId, search]);
  return {
    loading,
    applications,
    count,
    search,
    searchIndex,
  };
};
export const atsSurveyBannerIsDismissed = () =>
  notificationIsDismissed(NOTIFICATIONS.ORG_ADMIN_ATS_SURVEY_BANNER);
export const atsSurveyBannerShouldDisplay = () =>
  getNotificationStatus(NOTIFICATIONS.ORG_ADMIN_ATS_SURVEY_BANNER) === 'NEW';
export const dismissAtsSurveyBanner = () =>
  dismissNotification(NOTIFICATIONS.ORG_ADMIN_ATS_SURVEY_BANNER);
export const showAtsSurveyBanner = () => {
  if (!atsSurveyBannerIsDismissed()) {
    setNotificationStatus(NOTIFICATIONS.ORG_ADMIN_ATS_SURVEY_BANNER, 'NEW');
  }
};
export const getDefaultApplyAckText = (
  org: OrgDashboardApiOrg | StaffOrg,
  listing?: OrgDashboardApiListing | StaffListing,
) => {
  const locale = (listing && listing.locale) || org.locale;
  const orgName: string =
    // TODO: Fix this the next time the file is edited.
    // @ts-expect-error TS(2339): Property 'hasOrgNameOverride' does not exist on ty... Remove this comment to see the full error message
    // eslint-disable-next-line no-nested-ternary
    listing && listing.hasOrgNameOverride && listing.orgNameOverride
      ? // @ts-expect-error TS(2339): Property 'orgNameOverride' does not exist on type ... Remove this comment to see the full error message
        listing.orgNameOverride
      : org.name
      ? org.name
      : '';
  const showOrgName =
    (listing && !listing.isPostedAnonymously && orgName) || false;
  return {
    en: `<p>Your resume and application materials have been successfully submitted ${
      showOrgName ? `to ${orgName} ` : ''
    }for the listing below.</p><p>Best Regards,</p><p>The Idealist Community Support Team</p>`,
    es: `<p>Tu currículum y otros materiales para tu postulación se han enviado correctamente ${
      showOrgName ? `a ${orgName} ` : ''
    }para esta oportunidad.</p><p>Suerte,</p><p>El Equipo de Idealist en Español</p>`,
    pt: `<p>O seu currículo e material de inscrição foram submetidos com sucesso ${
      showOrgName ? `para ${orgName} ` : ''
    }para o anúncio abaixo.</p><p>Saudações,</p><p>Equipe de Suporte à Comunidade Idealista</p>`,
  }[locale];
};
const HAS_USED_ATS = 'hasUsedAts';
export const usedAts = () => localStorage.setItem(HAS_USED_ATS, true);
export const hasUsedAts = () => localStorage.getItem(HAS_USED_ATS);
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const hasLegacyStatuses = (listing: Record<string, any>) => {
  const { firstPublished } = listing;

  if (!firstPublished) {
    return false;
  }

  const firstPublishedDT = parseJSON(firstPublished);
  const newStatusStartDateDT = parseJSON(NEW_STATUS_START_DATE);
  return firstPublishedDT < newStatusStartDateDT;
};
